import { render, staticRenderFns } from "./addGoodsAssociate.vue?vue&type=template&id=8391795c&scoped=true"
import script from "./addGoodsAssociate.vue?vue&type=script&lang=ts"
export * from "./addGoodsAssociate.vue?vue&type=script&lang=ts"
import style0 from "./addGoodsAssociate.vue?vue&type=style&index=0&id=8391795c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8391795c",
  null
  
)

export default component.exports